// 产品名
export const PRODUCT_NAME = 'CodeFlicker';

export const PRODUCT_NAME_CN = 'CodeFlicker-CN';
export const PRODUCT_EMAIL = 'codeflicker@streamlake.com';

// 根据语言获取产品名称的工具函数
export const getProductNameByLanguage = (language: string) => {
  const isChinese = ['zh', 'zh-CN', 'zh-Hans', 'zh-Hant', 'zh-TW', 'zh-HK'].some((lang) =>
    language.toLowerCase().startsWith(lang.toLowerCase()),
  );
  return isChinese ? PRODUCT_NAME_CN : PRODUCT_NAME;
};
